export class MeeGroupPersonEntity{

    id: number;
    personId: number;
    groupId:number;

    constructor () {}
}